<template>
  <v-content>
    <v-container class="fill-height" fluid>
      <v-btn @click="goAllBars" color="accent">All Bars</v-btn>
      <v-row align="center" justify="center">
        <v-col cols="8">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Name"
                  name="name"
                  v-model="localBar.name"
                  type="text"
                />
                <v-textarea
                  label="Description"
                  v-model="localBar.description"
                />
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-expansion-panel-header>Hours</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <span
                        v-bind:key="index"
                        v-for="(item, index) in localBar.hours"
                      >
                        <label>{{ item.day }}</label>
                        <v-text-field
                          v-model="item.open"
                          label="Open"
                          type="text"
                        />
                        <v-text-field
                          v-model="item.close"
                          label="Close"
                          type="text"
                        />
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels class="expansion-margin-top">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      >Image URLs</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <v-btn @click="addURL" color="secondary">Add Entry</v-btn>
                      <span
                        v-bind:key="index"
                        v-for="(imageURL, index) in localBar.imageURLs"
                      >
                        <v-text-field
                          v-model="imageURL.url"
                          label="URL"
                        ></v-text-field>
                        <v-select
                          v-model="imageURL.description"
                          label="Description"
                          :items="descriptions"
                        />
                        <v-file-input
                          chips
                          label="Upload Photo"
                          v-model="imageURL.file"
                        ></v-file-input>
                        <v-btn
                          class="right-margin"
                          @click="signUpload(imageURL.file, imageURL)"
                          >Submit Photo</v-btn
                        >
                        <v-btn
                          v-if="index !== 0"
                          @click="removeURL(index)"
                          color="error"
                          >Remove Entry</v-btn
                        >
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels class="expansion-margin-top">
                  <v-expansion-panel>
                    <v-expansion-panel-header>Address</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-text-field
                        v-bind:key="index"
                        v-for="(value, key, index) in localBar.address"
                        v-model="localBar.address[key]"
                        :label="'Address ' + key"
                        type="text"
                      />
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels class="expansion-margin-top">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      >Daily Specials</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <span
                        v-bind:key="index"
                        v-for="(dailySpecial, index) in localBar.dailySpecials"
                      >
                        <v-checkbox
                          v-model="dailySpecial.selected"
                          :label="dailySpecial.day"
                        ></v-checkbox>
                        <v-text-field
                          v-model="dailySpecial.name"
                          label="Event Name"
                          type="text"
                        ></v-text-field>
                        <v-text-field
                          v-model="dailySpecial.imageURL"
                          label="Image URL"
                          type="text"
                        ></v-text-field>
                        <v-file-input
                          chips
                          label="Upload Photo"
                          v-model="dailySpecial.file"
                        ></v-file-input>
                        <v-btn
                          class="right-margin"
                          @click="signUpload(dailySpecial.file, dailySpecial)"
                          >Submit Photo</v-btn
                        >
                        <v-text-field
                          v-model="dailySpecial.description"
                          label="Description"
                          type="text"
                        ></v-text-field>
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels class="expansion-margin-top">
                  <v-expansion-panel>
                    <v-expansion-panel-header
                      >Happy Hours</v-expansion-panel-header
                    >
                    <v-expansion-panel-content>
                      <span
                        v-bind:key="index"
                        v-for="(happyHour, index) in localBar.happyHours"
                      >
                        <v-checkbox
                          v-model="happyHour.selected"
                          :label="happyHour.day"
                        ></v-checkbox>
                        <v-text-field
                          v-model="happyHour.imageURL"
                          label="Image URL"
                          type="text"
                        ></v-text-field>
                        <v-file-input
                          chips
                          label="Upload Photo"
                          v-model="happyHour.file"
                        ></v-file-input>
                        <v-btn
                          class="right-margin"
                          @click="signUpload(happyHour.file, happyHour)"
                          >Submit Photo</v-btn
                        >
                        <v-text-field
                          v-model="happyHour.description"
                          label="Description"
                          type="text"
                        ></v-text-field>
                        <v-text-field
                          v-model="happyHour.startTime"
                          label="Start Time"
                          type="text"
                        ></v-text-field>
                        <v-text-field
                          v-model="happyHour.endTime"
                          label="End Time"
                          type="text"
                        ></v-text-field>
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-expansion-panels class="expansion-margin-top">
                  <v-expansion-panel>
                    <v-expansion-panel-header>Prices</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <span
                        v-bind:key="index"
                        v-for="(price, index) in localBar.prices"
                      >
                        <v-select
                          v-model="price.name"
                          label="Name"
                          :items="priceNames"
                        />
                        <v-text-field
                          v-model="price.beer"
                          label="Lowest Beer"
                          type="number"
                        />
                        <v-text-field
                          v-model="price.wine"
                          label="Lowest Wine"
                          type="number"
                        />
                        <v-text-field
                          v-model="price.cocktail"
                          label="Lowest Cocktail"
                          type="number"
                        />
                      </span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <v-select
                  v-model="localBar.categories"
                  :items="categories"
                  label="Categories"
                  multiple
                  chips
                ></v-select>
                <v-checkbox
                  v-model="localBar.featured"
                  label="Featured"
                ></v-checkbox>
                <v-checkbox
                  v-model="localBar.published"
                  label="Published"
                ></v-checkbox>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-dialog
                v-if="formTitle === 'Edit Bar'"
                v-model="dialog"
                width="500"
              >
                <template v-slot:activator="{ on }">
                  <v-btn color="red lighten-2" dark v-on="on">Delete Bar</v-btn>
                </template>
                <v-card>
                  <v-card-title class="headline grey lighten-2" primary-title
                    >Are you sure?</v-card-title
                  >
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" text @click="dialog = false"
                      >Cancel</v-btn
                    >
                    <v-btn color="primary" text @click="confirmAndDelete"
                      >Delete</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-spacer />
              <v-btn color="primary" @click="cleanAndSubmit(localBar)"
                >Submit</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
import removeBarMutation from "../gql/removeBarMutation";
import signUploadMutation from "../gql/signUploadMutation";
import axios from "axios";
export default {
  props: {
    formTitle: String,
    bar: Object,
    submit: Function
  },
  data: function() {
    return {
      localBar: this.bar,
      dialog: false,
      priceNames: ["Normal", "Happy Hour"],
      descriptions: ["Atmosphere", "Drinks", "Food"],
      categories: [
        "Sports Bar",
        "Dive Bar",
        "Beer Bar",
        "Cocktail Bar",
        "Lounge",
        "Fancy Bar",
        "Rooftop Bar",
        "Club",
        "Restuarant Bar",
        "Cafe Bar",
        "Wine Bar",
        "Sake Bar",
        "Japanese Style Bar"
      ]
    };
  },
  methods: {
    signUpload(file, objectToModify) {
      this.$apollo
        .mutate({
          mutation: signUploadMutation
        })
        .then(
          ({
            data: {
              signUpload: { signature, timestamp }
            }
          }) => {
            if (signature && timestamp) {
              const formData = new FormData();
              formData.append("file", file);
              formData.append("signature", signature);
              formData.append("timestamp", timestamp);
              formData.append(
                "api_key",
                process.env.VUE_APP_CLOUDINARY_PUBLIC_KEY
              );
              formData.append("use_filename", true);
              axios
                .post(process.env.VUE_APP_CLOUDINARY_URI, formData)
                .then(({ data: { secure_url } }) => {
                  if (secure_url) {
                    if (objectToModify.hasOwnProperty("url")) {
                      objectToModify.url = secure_url;
                    } else if (objectToModify.hasOwnProperty("imageURL")) {
                      objectToModify.imageURL = secure_url;
                    }
                  }
                })
                .catch(e => {});
            }
          }
        )
        .catch(e => {});
    },
    goAllBars() {
      this.$router.push("all-bars");
    },
    addURL() {
      this.localBar.imageURLs.push({ url: "", description: "", file: [] });
    },
    removeURL(index) {
      this.localBar.imageURLs.splice(index, 1);
    },
    removeFile(imageURL) {
      if (imageURL.file) {
        delete imageURL.file;
      }
      return imageURL;
    },
    filterHappyHoursAndDailySpecials(arrayofObjects) {
      let filteredArray = arrayofObjects.filter(object => {
        if (object.selected) {
          delete object.selected;
          return this.removeFile(object);
        }
      });
      return filteredArray;
    },
    confirmAndDelete() {
      this.$apollo
        .mutate({
          mutation: removeBarMutation,
          variables: {
            id: this.bar._id
          }
        })
        .then(({ data: { removeBar } }) => {
          if (removeBar) {
            this.$store.commit({ type: "removeBar", payload: removeBar });
          }
          this.dialog = false;
          this.$router.push("all-bars");
        })
        .catch(e => {
          this.dialog = false;
        });
    },
    cleanAndSubmit(bar) {
      this.localBar.happyHours = this.filterHappyHoursAndDailySpecials(
        this.localBar.happyHours
      );
      this.localBar.dailySpecials = this.filterHappyHoursAndDailySpecials(
        this.localBar.dailySpecials
      );
      this.localBar.imageURLs = this.localBar.imageURLs.map(this.removeFile);
      this.submit(this.localBar);
    }
  }
};
</script>
<style lang="scss">
.expansion-margin-top {
  margin-top: 10px;
}
.right-margin {
  margin-right: 15px;
}
</style>
